import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { factoryItemsSchemaObject } from '../../Data'
import MessageModal from '../../../UI/Modal/MessageModal';
import { AddItems, ItemsSubTable } from '../Others'
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'FACTORYITEM';

export function FactoryItemsAddEdit(props) { 

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Factory Items")
    const [groups, setGroups] = useState()
    const [factories, setFactories] = useState()
    //const [products, setProducts] = useState()
    const [factoryItems, setFactoryItems] = useState({
        factoryItemID: 0,
        groupID: 0,
        operationEntityID: 0,
        factoryItemCode: '',
        factoryItemName: '',
        factoryItemDescription: '',
        isActive: true,
        itemCategoryID: 0,
        measuringUnit: 0
    });

    const [ItemCategoryList, setItemCategoryList] = useState();

    const [factoryItemList, setFactoryItemList] = useState([])
    const [buttonName, setButtonName] = useState("Save")
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
 
   
    const [isEditing, setIsEditing] = useState(false);
    const [pageProperties, setPageProperties] = useState({
        btnEnabled: true,
        dropDownDisabled: false,
        fieldsDisabled: false
    });
    const [editedCodes, setEditedCodes] = useState({
        codes: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(factoryItemsSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
            
        if (data && edit) {
            setTitle("Edit Factory Items");
            setFactoryItems(data);
            FactoryByGroupEntity(data.groupID);   
            //getProductsByEntityId(data.operationEntityID);
            setButtonName("Update")
        } else {
            setTitle("Add Factory Items")
        }
        
    }, [])

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(FactoryByGroupEntity(factoryItems.groupID))
    }, [factoryItems.groupID]);

    /*useEffect(() => {
        trackPromise(getProductsByEntityId(factoryItems.operationEntityID))
    }, [factoryItems.operationEntityID]);*/

    useEffect(() => {
        trackPromise(getAllActiveItemCategory());
    }, [factoryItems.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITFACTORYITEM');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });
        
        if (data && edit) {
            setTitle("Edit Factory Item");
            setFactoryItems(data);
            setButtonName("Update");
        } else {
            setTitle("Add Factory Item");
            var token = tokenService.getUserDetailsFromToken();
            setFactoryItems({
              ...factoryItems,
              groupID: token.groupID,
              operationEntityID: token.operationEntityID
            })
        }

        setGroupDropDownData()
    }



    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getAllActiveItemCategory() {
        const result = await services.getAllActiveItemCategory();
        setItemCategoryList(result);
      }

    /*async function getProductsByEntityId(entityID) {
        const result = await services.getProducts(entityID)
        setProducts(result)
    }*/

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'isActive' ? target.checked : target.value

       const error = { ...errors }
       const errorMessage = validateProperty(target, factoryItemsSchemaObject)
       errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        })
        setErrors(error)
    }

    function handleGroupChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, factoryItemsSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value,
            operationEntityID: 0
        })
        trackPromise(
            FactoryByGroupEntity(value)
            )
        setErrors(error)
    }


    function handleOperationEntityChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, factoryItemsSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        })

       /* setErrors(error);
        trackPromise(
            getProductsByEntityId(target.value)
            )*/
    }

    function handleChange1(e) {
        const target = e.target;
        const value = target.value
        setFactoryItems({
          ...factoryItems,
          [e.target.name]: value
        });
      }



   /* function handleProductTypeChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, factoryItemsSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        })
        setErrors(error);
    }*/


    async function FactoryByGroupEntity(groupId) {
        if (groupId > 0) {
            let filteredData = await services.getOperationalEntityByGroupEntityID(groupId);
            setFactories(filteredData)
        }
        else {
            setFactories([])
        }
    }


    async function handleSave(e) {
      
        e.preventDefault()

        const errorMessages = validate(schema, factoryItems)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

      
        if (!edit) {
            const response = await services.saveFactoryItems(factoryItems)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editData(factoryItems)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }


    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }


   

    function afterSuccessfulyChanged(response, factoryItems) {

        if (response === "Success") {
            clearState();

            setTimeout(() => {
                props.history.push({ pathname: '/factoryitems' })
            }, 1500);
        }
    }

    function clearState() {
        setFactoryItems({
            ...factoryItems,
            factoryItemID: 0,
            groupID: 0,
            operationEntityID: 0,
           // productID: 0,
            factoryItemCode: '',
            factoryItemName: '',
            factoryItemDescription: '',
            //price: 0,
            isActive: true,
            itemCategoryID: 0,
            measuringUnit: 0

        })
    }

    function clearButton() {
        setErrors({});
        if (edit) {
            setFactoryItems(data);
        } else {
            setFactoryItems({
                ...factoryItems,
                factoryItemID: 0,
                groupID: 0,
                operationEntityID: 0,
              //  productID: 0,
                factoryItemCode: '',
                factoryItemName: '',
                factoryItemDescription: '',
               // price: 0,
                isActive: true,
                itemCategoryID: 0,
                measuringUnit: 0
            })
        }

    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/factoryitems"
                        />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group Name *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={factoryItems.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={factoryItems.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleOperationEntityChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}

                                    </div>

                                   
                                </div>


                                <div className="form-group row">
                                    
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryItemCode">Item Code *</InputLabel>
                                        <TextField
                                            fullWidth
                                            name="factoryItemCode"
                                            id="factoryItemCode"
                                            type="text"
                                            value={factoryItems.factoryItemCode}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["factoryItemCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryItemCode"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryItemName">Item Name *</InputLabel>
                                        <TextField fullWidth
                                            name="factoryItemName"
                                            id="factoryItemName"
                                            type="text"
                                            value={factoryItems.factoryItemName}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["factoryItemName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryItemName"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="itemCategoryID">Item Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="itemCategoryID"
                                            name="itemCategoryID"
                                            value={factoryItems.itemCategoryID}
                                            onChange={(e) =>handleChange1(e)}>
                                            <MenuItem value="0">--Select Item Category--</MenuItem>
                                            {generateDropDownMenu(ItemCategoryList)}
                                        </Select>
                                        {errors["itemCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["itemCategoryID"]}</FormHelperText>}

                                    </div>

                                </div>

                                <div className="form-group row">

                                <div className="col-md pb-1">
                                        <InputLabel shrink id="measuringUnit">Measuring Unit*</InputLabel>
                                        <Select
                                            fullWidth
                                            id="measuringUnit"
                                            name="measuringUnit"
                                            value={factoryItems.measuringUnit}
                                            onChange={(e) => handleChange1(e)}>
                                            
                                            <MenuItem value="0">Kg</MenuItem>
                                            <MenuItem value="1">Litre</MenuItem>
                                            <MenuItem value="2">Unit</MenuItem>
                                        </Select>
                                        {errors["measuringUnit"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["measuringUnit"]}</FormHelperText>}

                                    </div>
                                   

                                   
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryItemDescription">Item Description *</InputLabel>
                                        <TextField
                                       fullWidth 
                                        name="factoryItemDescription"
                                        id="factoryItemDescription"
                                        type="text"
                                        value={factoryItems.factoryItemDescription}
                                        //disabled={fieldsDisabled}
                                            onChange={(e) => handleChange(e)} 
                                    />
                                        {errors["factoryItemDescription"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryItemDescription"]}</FormHelperText>}
 
                                    </div>
                                    
                                   
                                </div>
                               

                                    <label htmlFor="switch1" >Active</label>

                                    <div className="form-group row">
                                        <div className="col-md pb-1">
                                            <input
                                                className="mr-2"
                                                id="isActive"
                                                switch="none"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange(e)}
                                                checked={factoryItems.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>

                               
                            </div>
               
               
                
                            <div className="card-footer">

                                 <input
                                   disabled={validate(schema, factoryItems)}
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}
                                />
                                
                                <input type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={clearButton}
                                />
                            </div>
                        </form>

                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}